import IntakeResult from "@/pages/intakes/IntakeResult"
import { IntakeResultStepperContext } from "@/pages/intakes/intakeResultStepper"
import { useIntakeResultStore } from "@/stores/useIntakeResultStore"
import { checkIntakeResultsEditable } from "@/utils/checkIntakeResultsEditable"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen",
)({
  component: RouteComponent,
  beforeLoad: async ({ context, params }) => {
    checkPermissions("update", "intake")

    await checkIntakeResultsEditable({
      queryClient: context.queryClient,
      intakeId: Number(params.intakeId),
    })
  },
})

function RouteComponent() {
  const { intakeId, studentId, studentProjectOrganizationId } = useParams({
    from: "/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen",
  })

  const { currentStep } = useIntakeResultStore()

  return (
    <IntakeResultStepperContext initialStep={currentStep}>
      <IntakeResult
        intakeId={Number(intakeId)}
        studentId={Number(studentId)}
        studentProjectOrganizationId={Number(studentProjectOrganizationId)}
        type="edit"
      />
    </IntakeResultStepperContext>
  )
}
